import { render, staticRenderFns } from "./TotpVerify.vue?vue&type=template&id=b8906f8e&scoped=true&"
import script from "./TotpVerify.vue?vue&type=script&lang=js&"
export * from "./TotpVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8906f8e",
  null
  
)

export default component.exports